export class BalanceModel {
    balance: number;
    approved: number;
}